import { AnalyticsFilterSelection } from 'pages/ReportsPage/store/analyticsFilter.store.types';

const isCleared = (value: AnalyticsFilterSelection): boolean =>
  Array.isArray(value) && value.length === 0;

export function isSelectionCleared(
  locationIds: AnalyticsFilterSelection,
  positions: AnalyticsFilterSelection,
): boolean {
  return isCleared(locationIds) || isCleared(positions);
}
